import { useMemo } from "react";
import { Attribute } from "app/api/graph/security-attributes";

export type Result = {
    canDelete: boolean;
    canUpdate: boolean;
    canView: boolean;
};

export const useGeneralPermissions = (permissions: string[] | null | undefined): Result => {
    return useMemo(
        () => ({
            canDelete: permissions?.includes(Attribute.Delete) ?? false,
            canUpdate: permissions?.includes(Attribute.Update) ?? false,
            canView: permissions?.includes(Attribute.View) ?? false,
        }),
        [permissions],
    );
};
